import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { useWizard } from 'ui-components/components/wizard/context';

import { messages } from '../../../../../messages';
import style from '../style.module.less';
import { useDisabledButtonMessage } from './use-disabled-button-message';
import { useWalletRegistrationErrorContext } from '../../../contexts/wallet-registration-error-context';
import { useWalletRegistrationFormContext } from '../../../contexts/wallet-registration-form-context';
import { useWalletRegistrationModalContext } from '../../../contexts/wallet-registration-modal-context';
import { useTaxFormContext } from '../../../../../../pages/settings/payment-and-subscription/context/tax-form-context-provider';
import { PAYMENT_TAB } from '../../../../../utilities/constants';

export const ProgressButton = ({ disabled = false }) => {
  const { activeStep, canProgress, stepForward } = useWizard();
  const isPaymentTab = activeStep.stepId === PAYMENT_TAB;
  const disabledButtonMessage = useDisabledButtonMessage();
  const { setShowAllErrors } = useWalletRegistrationErrorContext();
  const { hasSubmittedPayment, setHasSubmittedPayment, isPaymentComplete, performValidateForm } = useWalletRegistrationFormContext();
  const { isInvalidForm: isInvalidTaxForm, isTaxSectionOpen } = useTaxFormContext();
  const { shouldShowAdyenDropInComponent } = useWalletRegistrationModalContext();

  useEffect(() => {
    if (canProgress) {
      setShowAllErrors(false);
    }
  }, [canProgress, setShowAllErrors]);

  useEffect(() => {
    if (isPaymentComplete && shouldShowAdyenDropInComponent) {
      setHasSubmittedPayment(false);
      stepForward();
    }
  }, [isPaymentComplete, stepForward, setHasSubmittedPayment, shouldShowAdyenDropInComponent]);

  const isAdyenActiveAndProcessing = isPaymentTab && shouldShowAdyenDropInComponent && hasSubmittedPayment;

  const isDisabled = (!isPaymentTab && disabled) || isAdyenActiveAndProcessing;
  const actionClicked = () => {
    if (isPaymentTab) {
      if (isTaxSectionOpen && isInvalidTaxForm()) {
        return;
      }

      if (isPaymentComplete) {
        stepForward();
      } else if (canProgress && shouldShowAdyenDropInComponent) {
        setHasSubmittedPayment(true);
      } else if (canProgress) {
        stepForward();
      } else {
        performValidateForm?.();
        setShowAllErrors(true);
      }
    } else {
      stepForward();
    }
  };
  return (
    <Button
      classname={style.button}
      disabled={isDisabled}
      disabledTooltipMessage={disabledButtonMessage}
      onClick={actionClicked}
      theme='primary'
    >
      <FormattedMessage {...messages.continueSetup} />
    </Button>
  );
};

ProgressButton.propTypes = {
  disabled: PropTypes.bool,
};
